import { PrivateCatalogService } from '../../../catalog-services/private-catalog-service';
export class PrivateWidgets extends PrivateCatalogService {
    create(widgetId, data, requestConfig) {
        // TODO: replace with POST
        return this.put(`/catalog/widgets/${widgetId}`, data, {
            ...requestConfig,
        });
    }
    remove(widgetId, requestConfig) {
        return this.delete(`/catalog/widgets/${widgetId}`, requestConfig);
    }
    updateSettings(widgetId, data, requestConfig) {
        return this.put(`/catalog/widgets/${widgetId}/settings`, data, requestConfig);
    }
}
//# sourceMappingURL=widgets.js.map